module.exports = __webpack_public_path__ + "images/mywort/mywort-logo--negative.png";


//////////////////
// WEBPACK FOOTER
// ./images/mywort/mywort-logo--negative.png
// module id = 1567
// module chunks = 4